import { combineReducers } from 'redux';
import { reducer as reduxAsyncConnect } from 'redux-connect';

import serverResponse from 'common/reducers/serverResponse';

export default combineReducers({
  reduxAsyncConnect,
  serverResponse,
});
